"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareOptionResponseModelType = void 0;
exports.ShareOptionResponseModelType = {
    User: "user",
    Group: "group",
    Key: "key",
};
